var map = {
	"./alizee_defan.jpg": 9381,
	"./bien_informado.jpg": 2020,
	"./fox_13_news.jpg": 3206,
	"./jaime_mendez_news.jpg": 7008,
	"./the_daly_migs_show_interview.jpg": 1821,
	"./wave_potter.jpg": 210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5946;